import React from 'react';
import MasterPage from 'components/MasterPage';
import { useState } from 'react';
import { Container, Form, Row, Col, Card, Button, Modal, Spinner, Tabs, Tab } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Redirect } from 'react-router';
import { api } from 'services';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { Phone, CNPJ } from 'helpers/Input';
import { Currency, currencyReverse} from 'helpers/Currency';
import './style.css';
import { channel } from 'redux-saga';
import CallRecord from './CallRecord';
import TicketEscalation from './TicketEscalation';

export default function(){
  const model = [
    {name:'channel',required:true},
    {name:'name',required:true},
    {name:'email',required:true},
    {name:'phone',required:true},

    {name:'company_name',required:true},
    {name:'company_phone',required:true},
    {name:'name_technical_contact',required:true},

    {name:'service_provider',required:true},
    {name:'call_number',required:true},
    {name:'opening_date',required:true},
    {name:'schedule',required:true},
    {name:'service_name',required:true},

    {name:'description',required:true},
  ];

  const [isLoad, setLoad] = useState(false)
  const [end, setEnd] = useState({isEnd:false, isError:false})

  const handleSubmit = (e,type,form) => {
    e.preventDefault();
    api
      .post('technical-support', form)
      .then(() => {
      })
      .catch(()=>{
      });
  };
  return (<>
    <Container>
      <Row className="mt-4">
        <WidgetsOutlined className="icon-title" />
        <h5 className="title-dashboard">Suporte Técnico</h5>
      </Row>
      <Row className="">
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 pt-4 pb-4 pr-4 pl-4 col-12">
          <Tabs defaultActiveKey="rc" id="technical_support">
            <Tab eventKey="rc" title="Registro de chamado">
              {/* {getForm(0, form0, setForm0)} */}
              <CallRecord/>
            </Tab>
            <Tab eventKey="ec" title="Escalonamento de chamado">
              {/* {getForm(1, form1, setForm1)} */}
              <TicketEscalation/>
            </Tab>
          </Tabs>
        </Card.Body>
      </Row>
    </Container>
    <Modal show={isLoad}>
      <Modal.Body>
        {!end.isEnd?(
          <div className="d-flex justify-content-center">
            <Spinner animation="border" role="status" 
            style={{height:'50px',width:'50px'}}
            className="p-2"
            >
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ):(
          <div className="d-flex justify-content-center">
            <div className="success">
              <div className="center_success">
                <div className="line1"></div>
                <div className="line2"></div>
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-center">
          {!end.isEnd?(
            <span className="p-2">Enviando contestação de comissão.</span>
          ):(
            <span className="p-2">Contestação de comissão enviada com sucesso!</span>
          )}
        </div>
      </Modal.Body>
    </Modal>
  </>);
}
